import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/billing/query/', 'bill');

tbl.add(new Xtc('id', 'Inv No').renderSlot('bill_id'))
tbl.add(new Xtc('matters', 'Matter(s)').noSort().renderSlot('matters'))
tbl.add(new Xtc('issue_date', 'Issue date').noSort().renderSlot('issue_date'))
tbl.add(new Xtc('due_date', 'Due in').noSort().renderSlot('due_date'))
tbl.add(new Xtc('payed_amount', 'Paid amount').noSort().renderSlot('paid'))
tbl.add(new Xtc('total_amount', 'Total amount').noSort().renderSlot('amount'))
tbl.add(new Xtc('payment', 'Payment').noSort().renderSlot('payment'))

export default tbl;

